const { PiwikUtils } = require("./PiwikUtils");
export class PiwikSIGMA {
	static CATEGORIA_DOWNLOAD  = "Download";
	static ACTION_PGRA_DOWNLOAD  = "Download PGRA";
	static ACTION_SEZIONI_DOWNLOAD  = "Download Sezioni Topografiche";
	static ACTION_DTM_DOWNLOAD  = "Download DTM";
	static ACTION_IDROGRAMMI_DOWNLOAD  = "Download Idrogrammi";

	/*
	* Track page
	*/
	static trackPage = function() {
		window._paq.push(['trackPageView']);
	};

	/*
 	* Download PGRA
 	*/
	static inviaStatisticaDownloadPGRA = function(object) {
		PiwikUtils.inviaStatistica(PiwikSIGMA.CATEGORIA_DOWNLOAD, PiwikSIGMA.ACTION_PGRA_DOWNLOAD, object);
	};

	/*
 	* Download SEZIONI Topografiche
 	*/
	 static inviaStatisticaDownloadSezoni = function(object) {
		PiwikUtils.inviaStatistica(PiwikSIGMA.CATEGORIA_DOWNLOAD, PiwikSIGMA.ACTION_SEZIONI_DOWNLOAD, object);
	};

	/*
 	* Download DTM
 	*/
	 static inviaStatisticaDownloadDTM = function(object) {
		PiwikUtils.inviaStatistica(PiwikSIGMA.CATEGORIA_DOWNLOAD, PiwikSIGMA.ACTION_DTM_DOWNLOAD, object);
	};

	/*
 	* Download Idrogrammi
 	*/
	 static inviaStatisticaDownloadIdrogrammi = function(object) {
		PiwikUtils.inviaStatistica(PiwikSIGMA.CATEGORIA_DOWNLOAD, PiwikSIGMA.ACTION_IDROGRAMMI_DOWNLOAD, object);
	};

}